<template>
  <div>
    <Popup
      v-model:show="upIntentionPopup"
      position="bottom"
      closeable
      :close-on-click-overlay="false">
      <div style="font-size: 14px;font-weight: bold;text-align: center;padding-top: 15px;">选择意向车型</div>
      <Divider />
      <div style="margin-top: -15px;">
        <van-list>
          <van-cell style="padding: 0;" v-for="(item,index) in optionList" :key="index" @click="selectRow(index)">
            <div class="option_list" :class="[selectKey==index?'select_row':'']">{{ item.name }}</div>
          </van-cell>
        </van-list>
      </div>
      <div style="display: flex;justify-content:center;margin-top: 10px;margin-bottom: 20px;">
        <van-button type="info" block style="width: calc(100% - 30px);" @click="keepSetup">保存</van-button>
      </div>
    </Popup>
  </div>
</template>
<script>
// eslint-disable-next-line no-unused-vars
import { ContactApi } from '@/api/contact'
import { Popup, Divider, Toast, Button } from 'vant'
export default {
  components: {
    Popup, Divider, Toast, Button
  },
  data () {
    return {
      upIntentionPopup: false,
      optionList: [],
      selectKey: null
    }
  },
  methods: {
    show (contactId) {
      this.contactId = contactId
      this.upIntentionPopup = true
      this.selectKey = null
      this.getIntentionList()
    },
    // 获取跟进状态列表
    getIntentionList () {
      ContactApi.contactIntentionIndex({
        contactId: this.contactId
      }).then((res) => {
        res.data.forEach((item, index) => {
          if (item.isSelect == 1) {
            this.selectKey = index
          }
        })
        this.optionList = res.data
      })
    },
    // 保存设置
    keepSetup () {
      ContactApi.contactIntentionUpdate({
        contactId: this.contactId,
        intentionId: this.optionList[this.selectKey].id
      }).then((res) => {
        Toast('设置成功')
        this.$emit('change', true)
        this.upIntentionPopup = false
      })
    },
    // 选择意向车型
    selectRow (index) {
      this.selectKey = index
    }
  }
}
</script>
<style scoped lang="less">
.option_list{
  text-align: center;
  padding: 15px 0;
  color: #595959;
  cursor: pointer;
}
.option_list:hover{
  background: #EFFAFF;
}
.select_row{
  color: #319CFF;
  background: #EFFAFF;
}
</style>
